export default __webpack_public_path__ + "static/media/LesTortues60s.56d15fb4.mp3";